<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Cliente - Editar</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" @submit.prevent="EditClient">
              <b-row>
                <b-col md="3"></b-col>
                <b-col md="3">
                  <b-form-group label="Tipo de Documento :">
                    <select
                      ref="document_type"
                      class="form-control"
                      v-model="client.document_type"
                    >
                      <option value="1">DNI</option>
                      <option value="6">RUC</option>
                      <option value="0">OTROS</option>
                    </select>
                    <small
                      v-if="errors.document_type"
                      class="form-text text-danger"
                      >Seleccione un tipo de documento</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Nro Documento :">
                    <b-input-group>
                      <b-form-input
                        v-model="client.document_number"
                        class="form-control"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button variant="info">
                          <b-icon icon="search"></b-icon
                        ></b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <small
                      v-if="errors.document_number"
                      class="form-text text-danger"
                      >Ingrese un nro de documento</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Nombres / Razón Social:" required>
                    <b-form-input
                      type="text"
                      ref="name"
                      v-model="client.name"
                      placeholder="Ingrese su nombre"
                    ></b-form-input>
                    <small v-if="errors.name" class="form-text text-danger"
                      >Ingrese un nombre o razón social</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Pais :" label-for="input-1">
                    <select
                      ref="country"
                      v-model="client.country"
                      class="form-control"
                    >
                      <option value="">-- Seleccione --</option>
                      <option value="PE">Peru</option>
                      <option value="CL">Chile</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Ubigeo :" label-for="input-1">
                    <select
                      ref="ubigee"
                      v-model="client.ubigee"
                      class="form-control"
                    >
                      <option value="">-- Seleccione --</option>
                      <option value="1">Tacna</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Dirección :" required>
                    <b-form-input
                      type="text"
                      ref="address"
                      v-model="client.address"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Teléfono :" required>
                    <b-form-input
                      type="text"
                      ref="phone"
                      v-model="client.phone"
                      placeholder="Ingrese su Telefono"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Email :" required>
                    <b-form-input
                      type="email"
                      ref="email"
                      v-model="client.email"
                      placeholder="Ingrese su email"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

      

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Estado :" label-for="input-1">
                    <select
                      ref="state"
                      v-model="client.state"
                      class="form-control"
                    >
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-button
                    type="submit"
                    class="form-control btn-primary"
                    >GUARDAR</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "ClientEdit",
  props: ["id_client"],
  data() {
    return {
      module:'Client',
      client: {
        id_client: "",
        document_type: "",
        document_number: "",
        name: "",
        country: "PE",
        ubigee: "",
        address: "",
        phone: "",
        email: "",
        state: 1,
      },

      ubigens: [],
      //errors
      errors: {
        document_type: false,
        document_number: false,
        name: false,
      },
      validate: false,
    };
  },
  mounted() {
    this.ViewClient();
  },
  methods: {
    ViewClient,
    EditClient,
    Validate,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};


//ver usuario
function ViewClient() {
  let id_client = je.decrypt(this.id_client);
  let me = this;
  let url = this.url_base + "client/view/" + id_client;

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 3,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.client.id_client = response.data.result.id_client;
        me.client.document_type = response.data.result.document_type;
        me.client.document_number = response.data.result.document_number;
        me.client.name = response.data.result.name;
        me.client.ubigee = response.data.result.ubigee;
        me.client.country = response.data.result.country;
        me.client.phone = response.data.result.phone;
        me.client.email = response.data.result.email;
        me.client.state = response.data.result.state;
      } else {
        Swal.fire("404", "A Ocurrido un error", "error");
      }
    })
    .catch((error) => {
      Swal.fire("422", "A Ocurrido un error", "error");
    });
}

//editar usuario
function EditClient() {
  // validacion de campos obligatorios
  this.Validate();
  if (this.validate) {
    return false;
  }

  let me = this;
  let url = this.url_base + "client/edit";
  let data = {
    id_client: this.client.id_client,
    document_type: this.client.document_type,
    document_number: this.client.document_number,
    name: this.client.name,
    country: this.client.country,
    ubigee: this.client.ubigee,
    address: this.client.address,
    phone: this.client.phone,
    email: this.client.email,
    state: this.client.state,
  };

  axios({
    method: "PUT",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json",
      token: this.token,
      module: this.module,
      role: 3,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        Swal.fire("Cliente", "Se ha modificado el cliente", "success");
      } else {
        Swal.fire("404", "A Ocurrido un error", "error");
      }
    })
    .catch((error) => {
      Swal.fire("422", "A Ocurrido un error", "error");
    });
}

//validacion de formulario
function Validate() {
  this.errors.id_client = this.client.id_client.length == 0 ? true : false;
  this.errors.document_type = this.client.document_type.length == 0 ? true : false;
  this.errors.document_number = this.client.document_number.length == 0 ? true : false;
  this.errors.name = this.client.name.length == 0 ? true : false;

  this.validate = this.errors.id_client == true ? true : false;
  this.validate = this.errors.document_type == true ? true : false;
  this.validate = this.errors.document_number == true ? true : false;
  this.validate = this.errors.name == true ? true : false;
}
</script>
